import { PhraseDommage } from './phrase-dommage.class';
import { PhraseVersion } from './phrase-version.class';
import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';
import { REACTIVE_NODE } from '@angular/core/primitives/signals';

/** Annexes cat nat sur les rapports qui ont ce dommage (ATLAS-190). */
export type AnnexesCatnat = 'non' | 'facultatives' | 'obligatoires';

export class Dommage {
	@Required
	@Primary
	id: number;

	@Required
	label: string;

	@Required
	version: PhraseVersion;

	@Required
	isActive: boolean;

	@Required
	rapportTitle: string;

	@Required
	investigationTitle: string;

	@Required
	hasCouleur: boolean;

	@Required
	isMulti: boolean;

	picto: string;

	@Required
	hasTdgSurface: boolean;
	@Required
	hasTdgHumidity: boolean;
	@Required
	hasTdgNbrSupport: boolean;
	@Required
	hasManual: boolean;

	phrases: PhraseDommage[];

	/**
	 * non : pas d'onglet Annexes ; facultatives : onglet proposé ; obligatoires : pas de
	 * validation du rapport sans au moins une annexe. Absent (données antérieures) = non.
	 */
	annexesCatnat?: AnnexesCatnat;
}
